// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"683c48d8","377":"bc7a6b4b","450":"84198036","696":"8d4ca0f3"}[chunkId] + ".chunk.css";
};